<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showBulkTagsReferences"
      >
        <i
          v-tooltip.bottom.hover="$t('SHOW_REFERENCES')"
          class="typcn typcn-flow-children"
          aria-hidden="true"
        />
        <span
          v-t="'SHOW_REFERENCES'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function m-t-3"
        @click="downloadBulkTags"
      >
        <i
          v-tooltip.bottom.hover="$t('DOWNLOAD')"
          class="fa fa-download"
          aria-hidden="true"
        />
        <span
          v-t="'DOWNLOAD'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <div class="action-icon">
      <button
        class="btn btn-list-function"
        :disabled="disabled"
        @click="deleteBulkTags"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
  </div>
</template>

<script>
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'BulkTagsActions',
  props:{
    currentBulkTag: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    deleteBulkTags() {
      this.$emit('deleteBulkTags', this.currentBulkTag);
    },
    collapseActions() {
      this.$emit('collapseActions', this.currentBulkTag.id);
    },
    showBulkTagsReferences() {
      this.$emit('showBulkTagsReferences', this.currentBulkTag.id);
    },
    downloadBulkTags() {
      this.$emit('downloadBulkTags', this.currentBulkTag);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>